import Axios from 'axios';
import { EXTERNAL_ACCOUNT_URL, APIBASE_URL } from '../config/cacheKey';
import {
    ICheckOtpRequest,
    ICheckOtpResponse,

} from '../models/account.model';
import { ApiResultModel } from '../models/common.model';
import { IExternalAccountRequest } from '../models/externalAccount.model';

export const ExternalAccountLogin = (data: IExternalAccountRequest): Promise<ApiResultModel<ICheckOtpResponse>> => {
    return Axios.post<ApiResultModel<ICheckOtpResponse>>(
        APIBASE_URL + EXTERNAL_ACCOUNT_URL + '/Login',
        data
    ).then((result) => {
        return result.data;
    });
};

